import { Component, OnInit, Input, ViewEncapsulation, Pipe } from '@angular/core';
import { PropertyService } from '../../property.service';
import { GlobalNamespace as _GlobalNS } from './../../../../environments/environment';
import { HeaderSummary } from '../../property';
import { fas } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-header-summary',
  templateUrl: './header-summary.component.html',
  styleUrls: ['./header-summary.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HeaderSummaryComponent implements OnInit {
  @Input() propertyStrategy: string;
  @Input() showTitle: boolean;
  headerSummaryData: HeaderSummary[] = [];
  loading = false;
  loadingAdditionalData = false;
  showSummary = false;
  summaryLoaded = false;
  headerClass = 'header-collapsed';
  displayConfigurationId: number;
  event: Event;
  displayChangelog = false;
  constructor(
    private propertySrv: PropertyService
  ) { }

  ngOnInit() {
    this.propertyStrategy = (this.propertyStrategy === undefined) ? '' : this.propertyStrategy;
    this.showTitle = (this.showTitle === undefined) ? false : this.showTitle;
    // showTitle is undefined -> component is called from WS
    if (!this.showTitle) {
      this.loadSummary();
    }
  }

  /*Load data onclick of additional data*/
  loadSummary(): void {
    this.showSummary = !this.showSummary;
    this.headerClass = (this.showSummary ? ' header-expanded' : ' header-collapsed');
    if (!this.summaryLoaded) {
      this.loading = true;
      this.propertySrv.HeaderSummary('HeaderSummary', this.propertyStrategy)
        .subscribe((response: any) => {
          this.headerSummaryData = response.data as HeaderSummary[];
          this.loading = false;
          this.summaryLoaded = true;
        });
    }
  }

  // Logic for show HoverOver pop up and its loader
  loadChangeLogData(event, detailDisplayConfigurationId: number): void {
    this.displayConfigurationId = detailDisplayConfigurationId;
    this.event = event;
    this.displayChangelog = true;
  }

  // hide changelog popup and its loader
  hideChangeLogPopup(): void {
    this.displayChangelog = false;
  }

}
